import {
  CLEAR_SELECTED_DOMAIN,
  GET_SELECTED_DOMAIN,
  SET_SELECTED_DOMAIN,
  SET_EVENT_STATE,
  SET_EVENT_Credit_Usage,
  SET_EVENT_TIMEZONE,
} from "./SelectedDomainTypes";

const getSelectedDomain = () => {
  return {
    type: GET_SELECTED_DOMAIN,
  };
};

const setSelectedDomain = (data) => {
  return {
    type: SET_SELECTED_DOMAIN,
    payload: data,
  };
};

const setEventState = (data) => {
  return {
    type: SET_EVENT_STATE,
    payload: data,
  };
};
const setEventCreditUsage = (data) => {
  return {
    type: SET_EVENT_Credit_Usage,
    payload: data,
  };
};
const setEventTimezone = (data) => {
  return {
    type: SET_EVENT_TIMEZONE,
    payload: data,
  };
};

const clearSelectedDomain = (data) => {
  return {
    type: CLEAR_SELECTED_DOMAIN,
    payload: data,
  };
};
const SelectedDomainAction = {
  getSelectedDomain,
  setSelectedDomain,
  setEventState,
  setEventCreditUsage,
  setEventTimezone,
  clearSelectedDomain,
};
export default SelectedDomainAction;
